module.exports = __webpack_public_path__ + "img/about_sharecode_1.2b06db1f.png";